/**
 * @fileoverview Agent definition for structural-refresh-composite-v1.
 *
 * Orchestrates a two-step pipeline for structural story refresh:
 *   1. divergence-report-v2 → diagnose structural drift
 *   2. structural-suggestions-v1 → propose concrete changes
 *
 * @category narrative.story.operations
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
export const definition: AppAgentDefinition = {
  id: 'structural-refresh-composite-v1',
  kind: 'composite',
  name: 'Structural Refresh (Composite)',
  description: 'Analyzes story divergence and proposes structural changes to storylines (beat moves, additions, removals, priority changes) as reviewable suggestions.',
  category: 'structure',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.story.operations',
    usedBy: [],
    composedOf: [
      'divergence-report-v2',
      'structural-suggestions-v1',
    ],
    relatedAgents: [
      'storyline-refresher-v2',
      'divergence-report-v2',
      'structural-suggestions-v1',
    ],
  },
};
